module.exports = __webpack_public_path__ + "static/bars2-da5c1c8b26311fc8e8da9f73d4035ba8.png";